export const checkIsElementScrollable = (selector: string) => {
  const elem = document.querySelector(selector);

  if (elem) {
    return elem.scrollHeight > elem.clientHeight;
  }

  return false;
};
